<div class="app-modal__overlay" (click)="handleOverlayClick()"></div>
<div class="app-modal__content" [ngClass]="modalType" #modal id="modal" role="dialog" aria-modal="true" aria-labelledby="modal__title" tabindex="0">
	<ng-template #modal__content></ng-template>
</div>
